import React, { useEffect, useState } from "react";
import axiosInstance from "../../AxiosInstance";

const EditUserDialog = ({ open, onClose, onSubmitSuccess,fetchUsers, initialUserData }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    role: "USER",
    status: "ACTIVE"
  });

  useEffect(() => {
    if (initialUserData) {
      setFormData({
        name: initialUserData.name || "",
        email: initialUserData.email || "",
        phoneNumber: initialUserData.phoneNumber || "",
        role: initialUserData.role || "USER",
        status: initialUserData.status || "ACTIVE"
      });
    }
  }, [initialUserData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (initialUserData) {
        // Edit user
        await axiosInstance.put(`/users/update/${initialUserData.id}`, formData);
      } else {
        // Add new user
        await axiosInstance.post("/users/register", formData);
      }
      onSubmitSuccess();
      fetchUsers();
    } catch (error) {
      console.error("Error submitting user form:", error);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-md w-96 shadow-lg">
        <h2 className="text-lg font-bold mb-4">
          {initialUserData ? "Edit User" : "Add User"}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <input
            type="text"
            name="phoneNumber"
            placeholder="Phone Number"
            value={formData.phoneNumber}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          >
            <option value="USER">USER</option>
            <option value="ADMIN">ADMIN</option>
          </select>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          >
            <option value="ACTIVE">ACTIVE</option>
            <option value="INACTIVE">INACTIVE</option>
          </select>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserDialog;
